import { BadRequestError } from '@cian/valuation-utils-component';

import { TThunkAction } from '../../types/redux';
import { failureAction, requestAction, successAction } from './actions';
import {
  fetchGetEstimationHistoryByDealTypeWeb,
  TGetEstimationHistoryByDealTypeWebRequest,
  TGetEstimationHistoryByDealTypeWebResponse
} from '../../repositories/price-estimator/v1/get-estimation-history-by-deal-type-web';
import { selectApiParameters } from '../../selectors/estimation';
import { selectDealType } from '../../selectors/page';
import {
  IEstimationHistoryResponse1
} from "../../repositories/price-estimator/entities/estimation_history/EstimationHistoryResponse1";

export const getEstimationChartData =
  (): TThunkAction<Promise<IEstimationHistoryResponse1 | Error>> => async (dispatch, getState, ctx) => {
    const state = getState();
    const dealType = selectDealType(state);

    dispatch(requestAction());

    const parameters: TGetEstimationHistoryByDealTypeWebRequest = {
      ...selectApiParameters(state),
      dealType,
    };

    try {
      const res = (await fetchGetEstimationHistoryByDealTypeWeb({
        httpApi: ctx.httpApi,
        parameters,
      })) as TGetEstimationHistoryByDealTypeWebResponse;

      if (res.statusCode !== 200) {
        throw new BadRequestError({
          domain: 'getEstimationChartData.ts',
          message: res.response.message as string,
          details: { errors: JSON.stringify(res.response.errors) },
        });
      }

      dispatch(successAction(res.response.data || null));

      return res.response;
    } catch (e) {
      dispatch(failureAction());

      if (!(e instanceof BadRequestError)) {
        ctx.logger.error(e, {
          message: 'Ошибка при загрузке данных',
          domain: 'getEstimationChartData.ts',
          parameters: JSON.stringify(parameters),
        });
      }

      return e as Error;
    }
  };
